import { render } from "./UltraCardBrand.vue?vue&type=template&id=7ba58780&scoped=true"
import script from "./UltraCardBrand.vue?vue&type=script&lang=js"
export * from "./UltraCardBrand.vue?vue&type=script&lang=js"

import "./UltraCardBrand.vue?vue&type=style&index=0&id=7ba58780&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/AcivgTheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba58780"]])

export default __exports__